import PalmerNavbar from './components/PalmerNavbar';
import PalmerHero from './components/PalmerHero';
import PalmerWork from './components/PalmerWork';
import PalmerServices from './components/PalmerServices';
import PalmerAbout from './components/PalmerAbout';
import PalmerExperience from './components/PalmerExperience';
import PalmerTestimonials from './components/PalmerTestimonials';
import PalmerAwards from './components/PalmerAwards';
import PalmerClients from './components/PalmerClients';
import PalmerPricing from './components/PalmerPricing';
import PalmerBlog from './components/PalmerBlog';
import PalmerFAQ from './components/PalmerFAQ';
import PalmerFooter from './components/PalmerFooter';

export default function HomePage() {
  return (
    <div className="bg-black min-h-screen">
      <PalmerNavbar />
      <PalmerHero />
      <PalmerWork />
      <PalmerServices />
      <PalmerAbout />
      <PalmerExperience />
      <PalmerTestimonials />
      <PalmerAwards />
      <PalmerClients />
      <PalmerPricing />
      <PalmerBlog />
      <PalmerFAQ />
      <PalmerFooter />
    </div>
  );
}
